import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router-dom";
import {loadUserData} from "../../../actions/userAction";
import {
    currentUserId,
    currentUserLogin,
    currentUserRoles
} from "../../../utils/authUtils";
import {executeRetentionEvent} from "../../../actions/retentionEventActions";
import {loginAsPartner, logoutFromPartner} from "../../../actions/authActions";
import {openPage} from "../../../actions/historyActions";
import BasePageView from "./BasePageView";
import {getBasePageLinksData} from "./basePageNavigation";
import {getBasePagePartnerId, syncBasePagePartnerMode} from "./basePagePartnerMode";
import {
    applyBasePageResizeEffects,
    applyBasePageRouteEffects,
    handleBasePageDocumentClick,
    setBasePageTitle,
} from "./basePageDomEffects";

const userParams = {
    UserID: currentUserId(),
    login: currentUserLogin(),
    roles: currentUserRoles()
};

export default function BasePage({content, footerSearch}) {
    const dispatch = useDispatch();
    const location = useLocation();
    const auth = useSelector(state => state.auth);

    const getLinksData = () => {
        return getBasePageLinksData(auth, getBasePagePartnerId());
    };

    useEffect(() => {
        syncBasePagePartnerMode(auth, {
            loginAsPartner: () => dispatch(loginAsPartner()),
            logoutFromPartner: () => dispatch(logoutFromPartner()),
        });
    }, [auth.isAdminAsPartner, dispatch, location.search]);

    useEffect(() => {
        window.addEventListener('resize', applyBasePageResizeEffects);
        document.addEventListener('click', handleBasePageDocumentClick);
        setBasePageTitle((callback) => dispatch(loadUserData((partner) => callback(partner))));
        dispatch(executeRetentionEvent(() => {}));

        return () => {
            window.removeEventListener('resize', applyBasePageResizeEffects);
            document.removeEventListener('click', handleBasePageDocumentClick);
        };
    }, [dispatch]);

    useEffect(() => {
        applyBasePageRouteEffects();
    }, [location.pathname, location.search]);

    useEffect(() => {
        dispatch(openPage());
    }, [dispatch, location.pathname, location.search]);

    return (
        <BasePageView
            content={content}
            footerSearch={footerSearch}
            getLinksData={getLinksData}
            userParams={userParams}
        />
    );
}
